import { Link } from "react-router-dom";
import projects from "../data/projects";

const Work = () => {
    return (
        <div className="gallery-container">
            {projects.map((p) => {
                const hasImage = p.image && p.image.trim() !== "";

                return (
                    <Link to={`/project/${p.id}`} key={p.id} className="gallery-item">
                        {hasImage ? (
                            <img src={p.image} alt={p.title} />
                        ) : (
                            <div
                                className="gallery-fallback"
                                style={{ backgroundColor: p.bgColor || "#444" }}
                            >
                                <img src={p.logo} alt={p.title} className="fallback-logo" />
                            </div>
                        )}
                    </Link>
                );
            })}
        </div>
    );
};

export default Work;
